/* eslint-disable no-undef */
import "bootstrap";
import "./store-state.js";
import "./response-status.js";
import "./helpers/breadcrumbs-helper.js";
import axios from "axios";

import "../Content/js/vendor/metisMenu.js";
import "../Content/js/vendor/jquery.slimscroll.js";
import "../Content/js/vendor/waves.js";
import "../Content/libs/contextual/contentual.js";
import "../Content/libs/bootstrap-select/bootstrap-select.min.js";
//import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.js";

import "../Content/libs/jquery-steps/jquery.steps.min.js";
//import '../Content/js/pages/form-wizard.init.js';
import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.js";
import "../Content/libs/contextual/contentual.js";
import "../Content/libs/rwd-table/rwd-table.min.js";
import "../Content/libs/imageviewer/imageviewer.min.js";

//js helpers
import "./helpers/side-menu-link-helper.js";
import "./helpers/side-menu-helper.js";
import "./utils/casting-utilities.js";
import "./helpers/currency-helper.js";
import "./helpers/array-helper.js";
import "./helpers/roundingValue-helper.js";
import "./helpers/tooltip-helper.js";
import "./helpers/pageTitle-helper.js";
import "./helpers/contentType-helper.js";
import "./helpers/role-helper.js";
import "./helpers/order-helper.js";
import "./helpers/product-helper.js";
import "./helpers/localStorageCache-helper.js";
//import "./helpers/file-helper.js";
//import "./helpers/permissions-helper.js";
import "./helpers/httpResponseCode-helper.js";
import "./helpers/apiResponseHandler-helper.js";
//import "./helpers/siteManagementResponseCodes-helper.js";
import "./helpers/controls/dataTable-helper.js";

import * as echarts from "echarts";
import "../Content/libs/echarts/theme.js";
//services
import "./services/security-service.js";
import './services/system-service.js';
import "./services/customer-service.js";
import "./services/product-service.js";
import "./services/settings-service.js";
import "./services/report-service.js";
import "./services/rewards-service.js";
import "./services/competition-service.js";

import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "../Content/libs/bootstrap-select/bootstrap-select.min.css";
import "../Content/scss/icons.scss";

// permissions helper
import "./helpers/permissions-helper.js";

import "../Content/fonts/Segeo/segeoFont.css";

import "../Content/scss/app.scss";

import "../Content/style.css";

//import "../Content/scss/_variables.scss";
//import * as echarts from "echarts";
//import "../Content/libs/echarts/theme.js";

import { vMaska } from "maska"
import VueDatePicker from '@vuepic/vue-datepicker';
import '../Content/vueDatepicker/main.css';
//import maska from "maska";

//vue plugins
import { createRouter, createWebHashHistory } from "vue-router";

window.axios = axios;
window.echarts = echarts;
window.moment = moment;

import TestComponent from "./components/test/test.vue";

//common
import LoadingSpinner from "./components/controls/loadingSpinner/LoadingSpinner.vue";
import DataTable from "./components/controls/dataTable/DataTable.vue";
import DatePicker from "./components/controls/datePicker/DatePicker.vue";
import SuccessModal from "./components/controls/successModal/SuccessModal.vue";
import ErrorModal from "./components/controls/errorModal/ErrorModal.vue";
import BootstrapSelect from "./components/controls/bootstrapSelect/BootstrapSelect.vue";
import ModalForm from "./components/controls/modalForm/ModalForm.vue";
import PasswordGenerator from "./components/controls/passwordGenerator/PasswordGenerator.vue";
import PasswordGeneratorModal from "./components/controls/passwordGeneratorModal/PasswordGeneratorModal.vue";
import ModalMessage from "./components/controls/modalMessage/ModalMessage.vue";
import ActiveInactiveRadioButtons from "./components/controls/activeInactiveRadioButtons/ActiveInactiveRadioButtons.vue";
import FromDateToDatePickers from "./components/controls/fromDateToDatePickers/FromDateToDatePickers.vue";
import MarkAsActiveInactiveModal from "./components/controls/markAsActiveInactiveModal/MarkAsActiveInactiveModal.vue";
import CurrencyInput from "./components/controls/currencyInput/CurrencyInput.vue";
import Wizard from "./components/controls/wizard/Wizard.vue";
import PasswordUpdateModal from "./components/controls/passwordUpdateModal/PasswordUpdateModal.vue";
import ConfirmationModal from "./components/controls/confirmationModal/ConfirmationModal.vue";
import ModalTable from "./components/controls/modalTable/ModalTable.vue";

import LogsTable from "./components/Dashboard/controls/logsTable/LogsTable.vue";
import Dashboard from "./components/Dashboard/Dashboard.vue";

//common customer components
import LoyaltyCustomersManagement from "./components/loyaltyCustomersManagement/LoyaltyCustomersManagement.vue";

import CustomerTransactions from "./components/loyaltyCustomersManagement/customerTransactions/CustomerTransactions.vue";

import PromotionsManagement from "./components/campaignManagement/promotionsManagement/PromotionsManagement.vue";
import AddOrEditPromotion from "./components/campaignManagement/promotionsManagement/addOrEditPromotion/AddOrEditPromotion.vue";
import LinkProductsToPromotionModal
	from "./components/campaignManagement/promotionsManagement/addOrEditPromotion/common/linkProductsToPromotionModal/LinkProductsToPromotionModal.vue";

import PointsEarnManagement
	from "./components/campaignManagement/pointsManagement/pointsEarnManagement/PointsEarnManagement.vue";
import PointsRedeemManagement from "./components/campaignManagement/pointsManagement/pointsRedeemManagement/PointsRedeemManagement.vue";

// competition components
import CampaignManagement from "./components/competitionManagement/CampaignManagement/CampaignManagement.vue";
import AddOrUpdateCampaignModal
	from "./components/competitionManagement/CampaignManagement/AddOrUpdateCampaignModal/AddOrUpdateCampaignModal.vue";
import DrawWinnerModal from "./components/competitionManagement/CampaignManagement/DrawWinnerModal/DrawWinnerModal.vue";
import ViewSubmissionModal
	from "./components/competitionManagement/SubmissionManagement/ViewSubmissionModal/ViewSubmissionModal.vue";
import SubmissionManagement from "./components/competitionManagement/SubmissionManagement/SubmissionManagement.vue";
// import Customers from "./components/customers/Customers.vue";
// import AddEditCustomer from "./components/customers/AddEditCustomer/AddEditCustomer.vue";
// import CustomerUsers from "./components/customers/customerUsers/CustomerUsers.vue";
// import AddOrEditCustomerUser from "./components/customers/customerUsers/AddOrEditCustomerUser/AddOrEditCustomerUser.vue";
// import CustomerAddresses from "./components/customers/customerAddresses/CustomerAddresses.vue";
// import TransactionHistory from "./components/customers/transactionHistory/TransactionHistory.vue";
// import CustomerDiscountGroups from "./components/customers/customerDiscountGroups/CustomerDiscountGroups.vue";
// import CustomerVehicles from "./components/customers/CustomerVehicles/CustomerVehicles.vue";
// import PeopleToNotify from "./components/customers/CustomerVehicles/peopleToNotify/PeopleToNotify.vue";

import UserManagement from "./components/userManagement/UserManagement.vue";


import { createApp } from "vue";


let options = {
	data() {
		return {
			sharedState: storeState.state,
			breadcrumbs: [],
			maxBreadcrumbs: 3,
			breadcrumbsSessionKey: "breadcrumbs",
			isRefreshed: true,
			breadcrumbState: breadcrumbsStoreState.breadcrumbsState,
			//hideTitleBar: false,
			welcomePageReplacedInNavigationHistory: false,
			shouldReplaceUrl: true
		};
	},
	methods: {
		navigateToNewRoot(route){
			if(!this.welcomePageReplacedInNavigationHistory){
				this.$router.replace(route);
				this.welcomePageReplacedInNavigationHistory = true;
			}
			else{
				this.$router.push(route);
			}
		},
		determineIfMenuItemsShouldReplaceUrl(){
			if(window.location.hash === "#/"){
				this.shouldReplaceUrl = true;
			}
			else{
				this.shouldReplaceUrl = false;
			}
		}
	},
	components: {
	},
	mounted: function () {
		//this.loadBreadcrumbs();
		permissionsHelper.getPermissions(false, false);
		let hasLoggedIn = false;
		let hasLoggedSession = sessionStorage.getItem("hasLoggedInSession");
		if(hasLoggedSession !== null){
			hasLoggedIn = castingUtility.toBoolean(hasLoggedSession);
		}
		else{
			sessionStorage.setItem("hasLoggedInSession", "true");
		}
		if(!hasLoggedIn){
			// permissionsHelper.getPermissions(false, false);
			let menuItems = document.getElementById("side-menu").querySelectorAll("li > a");
			for(let i = 0; i < menuItems.length; i++){
				if(!menuItems[i].classList.contains("menuItemLink")){
					let newHomeRoute = menuItems[i].hash.replace("#", "");
					this.$router.replace(newHomeRoute);
					break;
				}
			}
		}
		breadcrumbsStoreState.loadBreadcrumbs();
		setTimeout(function (){
			sideMenuLinksHelper.updateActiveLinks();
		}, 100);
	},
	watch: {
		'$route':{
		    handler: function(){
		        console.log("route app js", this.$route);
				permissionsHelper.setCurrentRoute(this.$route);
		    },
		    immediate: true,
		    deep: true
		},
		breadcrumbState:{
			handler: function(){
				this.breadcrumbs = breadcrumbsStoreState.getBreadcrumbsToDisplay();
			},
			immediate: true,
			deep: true
		}
	}
};

const app = createApp(options).directive("maska", vMaska);

app.component("VueDatePicker", VueDatePicker);

app.component("test", TestComponent);
app.component("loading-spinner", LoadingSpinner);
app.component("logs-table", LogsTable);
app.component("data-table", DataTable);
app.component("date-picker", DatePicker);
app.component("success-modal", SuccessModal);
app.component("error-modal", ErrorModal);
app.component("bootstrap-select", BootstrapSelect);
app.component("modal-form", ModalForm);
app.component("modal-message", ModalMessage);
app.component("password-generator-modal", PasswordGeneratorModal);
app.component("password-generator", PasswordGenerator);
app.component("active-inactive-radio-buttons", ActiveInactiveRadioButtons);
app.component("from-date-to-date-pickers", FromDateToDatePickers);
app.component("mark-as-active-inactive-modal", MarkAsActiveInactiveModal);
app.component("currency-input", CurrencyInput);
app.component("wizard", Wizard);
app.component("password-update-modal", PasswordUpdateModal);
app.component("confirmation-modal", ConfirmationModal);
app.component("modal-table", ModalTable);
app.component("link-products-to-promotion-modal", LinkProductsToPromotionModal);
app.component("add-or-update-campaign-modal", AddOrUpdateCampaignModal);
app.component("draw-winner-modal", DrawWinnerModal);
app.component("view-submission-modal", ViewSubmissionModal);

//app.use(vMaska);

//global filters
app.config.globalProperties.$filters = {
	dateShortForm(date, showTime) {
		if(showTime){
			// eslint-disable-next-line no-undef
			return moment(date).format("DD MMM YYYY HH:mm");
		}
		// eslint-disable-next-line no-undef
		return moment(date).format("DD MMM YYYY");
	},
	toRands(value){
		return currencyHelper.numberToCurrency(value);
	}
};

if (document.getElementById("spa-page")){
	const routes = [
		{ 
			path: "/", 
			component: Dashboard
		},
		{ 
			path: "/customers", 
			component: LoyaltyCustomersManagement
		},
		{
			path: "/customers/transactions/:customerId?", 
			component: CustomerTransactions,
			props: true
		},
		{
			path: "/campaignManagement/promotionsManagement",
			component: PromotionsManagement,
		},
		{
			path: "/campaignManagement/promotionsManagement/addPromotion",
			component: AddOrEditPromotion,
		},
		{
			path: "/campaignManagement/promotionsManagement/editPromotion/:promotionId?",
			component: AddOrEditPromotion,
			props: true
		},
		{
			path: "/campaignManagement/pointsManagement/pointsEarnManagement",
			component: PointsEarnManagement
		},
		{
			path: "/campaignManagement/pointsManagement/pointsRedeemManagement",
			component: PointsRedeemManagement
		},
		{
			path: "/competitionManagement/campaignManagement",
			component: CampaignManagement
		},
		{
			path: "/competitionManagement/submissionManagement/:campaignId?",
			component: SubmissionManagement,
			props: true
		},
		// { 
		// 	path: "/customers/addEditCustomer/:companyId?", 
		// 	component: AddEditCustomer,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerUsers/:companyId?", 
		// 	component: CustomerUsers,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerUsers/addCustomerUser/:companyId?", 
		// 	component: AddOrEditCustomerUser,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerUsers/editCustomerUser/:userId?/:companyId?", 
		// 	component: AddOrEditCustomerUser,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerAddresses/:companyId?", 
		// 	component: CustomerAddresses,
		// 	props: true
		// },
		// {
		// 	path: "/customers/transactionHistory/:companyId?", 
		// 	component: TransactionHistory,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerDiscountGroups/:companyId?",
		// 	component: CustomerDiscountGroups,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerVehicles/:companyId?",
		// 	component: CustomerVehicles,
		// 	props: true
		// },
		// {
		// 	path: "/customers/customerVehicles/peopleToNotify/:vehicleId?/:companyId?",
		// 	component: PeopleToNotify,
		// 	props: true
		// },
		{
			path: "/userManagement",
			component: UserManagement
		}
	];

	const router = createRouter({
		history: createWebHashHistory(),
		//history: createWebHistory('Portal/Home'),
		routes, // short for `routes: routes`
	});
	app.use(router);
}

if (document.getElementById("app")) {
	//load vue js options on specific pages
	app.mount("#app");
}

